import React, { useState } from "react";
import "./NewAdmission.css";
import {
  FaUserPlus,
  FaArrowLeft,
  FaSave,
  FaCheckCircle,
  FaTimesCircle,
} from "react-icons/fa";

const NewAdmission = ({ token, onBack }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    dob: "",
    gender: "Male",
    grade: "Nursery",
    parentName: "",
    phone: "",
    email: "",
    address: "",
    medicalNotes: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [statusMessage, setStatusMessage] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatusMessage(null);

    try {
      // Replace with API submission logic
      await new Promise((resolve) => setTimeout(resolve, 800));

      setStatusMessage({
        type: "success",
        text: `Admission successfully submitted for ${formData.fullName}!`,
      });

      // Reset form
      setFormData({
        fullName: "",
        dob: "",
        gender: "Male",
        grade: "Nursery",
        parentName: "",
        phone: "",
        email: "",
        address: "",
        medicalNotes: "",
      });
    } catch (error) {
      console.error("Admission error:", error);
      setStatusMessage({
        type: "error",
        text: "Failed to process admission. Please try again.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="admission-container">
      <div className="admission-header">
        <button className="back-btn" onClick={onBack} type="button">
          <FaArrowLeft /> Back to Dashboard
        </button>
        <h2>
          <FaUserPlus className="header-icon" /> New Student Registration
        </h2>
      </div>

      {statusMessage && (
        <div className={`status-banner ${statusMessage.type}`}>
          {statusMessage.type === "success" ? (
            <FaCheckCircle className="banner-icon" />
          ) : (
            <FaTimesCircle className="banner-icon" />
          )}
          <span>{statusMessage.text}</span>
        </div>
      )}

      <form className="admission-form-card" onSubmit={handleSubmit}>
        <div className="form-section">
          <h3>Student Information</h3>
          <div className="form-grid">
            <div className="form-group">
              <label>Full Name *</label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                required
                placeholder="Student's complete name"
              />
            </div>

            <div className="form-group">
              <label>Date of Birth *</label>
              <input
                type="date"
                name="dob"
                value={formData.dob}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Gender *</label>
              <select name="gender" value={formData.gender} onChange={handleChange}>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="form-group">
              <label>Applying For Class *</label>
              <select name="grade" value={formData.grade} onChange={handleChange}>
                <option value="Playgroup">Playgroup</option>
                <option value="Nursery">Nursery</option>
                <option value="LKG">LKG</option>
                <option value="UKG">UKG</option>
                <option value="Daycare">Daycare</option>
              </select>
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Parent / Guardian Information</h3>
          <div className="form-grid">
            <div className="form-group">
              <label>Primary Guardian Name *</label>
              <input
                type="text"
                name="parentName"
                value={formData.parentName}
                onChange={handleChange}
                required
                placeholder="Parent or Guardian Name"
              />
            </div>

            <div className="form-group">
              <label>Contact Phone *</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                required
                placeholder="10-digit mobile number"
              />
            </div>

            <div className="form-group">
              <label>Email Address</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="guardian@example.com"
              />
            </div>

            <div className="form-group full-width">
              <label>Residential Address *</label>
              <textarea
                name="address"
                rows="2"
                value={formData.address}
                onChange={handleChange}
                required
                placeholder="Full residential address"
              ></textarea>
            </div>
          </div>
        </div>

        <div className="form-section">
          <h3>Additional / Medical Details</h3>
          <div className="form-group full-width">
            <label>Medical Allergies or Notes (If any)</label>
            <textarea
              name="medicalNotes"
              rows="2"
              value={formData.medicalNotes}
              onChange={handleChange}
              placeholder="List any food allergies, dietary restrictions, or medical alerts..."
            ></textarea>
          </div>
        </div>

        <div className="form-actions">
          <button type="submit" className="btn-submit" disabled={isSubmitting}>
            <FaSave /> {isSubmitting ? "Registering..." : "Submit Registration"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default NewAdmission;